import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsProjectAddComp from "./Component/TsProjectAddComp"


const TsProjectAdd =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsProjectAddComp />
        </div>
        <Footer />
        </>
    )
}

export default TsProjectAdd